import { Actions } from "../types/masks";
import { TaskError, TaskErrorType } from "../types/task";

export const MAX_TIME_EXPIRATION = 60 * 60 * 1000; // 60min

export const ACTIONS: Actions = {
  CREATE_OCCURRENCE: {
    type: "CREATE_OCCURRENCE",
    message: "Màscara creada per",
  },
  DELETE_OCCURRENCE: {
    type: "DELETE_OCCURRENCE",
    message: "Màscara eliminada per",
  },
  DELETE_MASK: {
    type: "DELETE_MASK",
    message: "Totes les ocurrències eliminades per",
  },
};

export const PROCESSING_ERRORS: { [key in TaskErrorType]: TaskError } = {
  TypelessAnnotationException: {
    type: "TypelessAnnotationException",
    message: "Invalid PDF Annotation",
  },
  UnreadableJustificationTableError: {
    type: "UnreadableJustificationTableError",
    message: "Unreadable Justification Table",
  },
  InvalidJustificationTableError: {
    type: "InvalidJustificationTableError",
    message: "Invalid Justification Table",
  },
  ProcessingError: {
    type: "ProcessingError",
    message: "Unknown error. Please contact support",
  },
};


export const CRITERIA_OPTIONS = [
  { label: "Nom i/o cognoms", value: "NAME" },
  { label: "Números identificatius", value: "IDENTIFIER" },
  { label: "Adreces postals", value: "ADDRESS" },
  // { label: "Noms d'empreses", value: "COMPANY" },
  { label: "Dates", value: "DATE" },
  { label: "Telèfons", value: "PHONE" },
  { label: "Correus electrònics", value: "EMAIL" },
  { label: "Identificadors bancaris", value: "BANK" },
  { label: "Matrícules", value: "MATRICULE" },
  { label: "IP", value: "IP" },
];

export const STATUS_OPTIONS = [
  { label: "En anonimització", value: "PENDING" },
  { label: "En anonimització", value: "RUNNING" },
  { label: "Complet", value: "SUCCESS" },
  { label: "Error", value: "FAILED" },
  { label: "Cancel·lada", value: "CANCELLED" },
];

export const FILTERED_STATUS_OPTIONS = [
  { label: "En anonimització", value: "RUNNING" },
  { label: "Complet", value: "SUCCESS" },
  { label: "Error", value: "FAILED" },
];

export const VALIDATION_OPTIONS = [
  { label: "Validada", value: "VALIDATED" },
  { label: "Pendent de revisió", value: "REVISION" },
];